export enum customerReviewMicrocopy {
  CUSTOMER_REVIEWS_SUMMARY_GOOGLE_COUNT = 'CUSTOMER_REVIEWS_SUMMARY_GOOGLE_COUNT',
  CUSTOMER_REVIEWS_SUMMARY_GOOGLE_AVERAGE = 'CUSTOMER_REVIEWS_SUMMARY_GOOGLE_AVERAGE',
  CUSTOMER_REVIEWS_SUMMARY_PRODUCT_REVIEW_COUNT = 'CUSTOMER_REVIEWS_SUMMARY_PRODUCT_REVIEW_COUNT',
  CUSTOMER_REVIEWS_SUMMARY_PRODUCT_REVIEW_AVERAGE = 'CUSTOMER_REVIEWS_SUMMARY_PRODUCT_REVIEW_AVERAGE',
}
